export const LIST = 'list';
export const CHART = 'chart';
export const NUMBER = 'number';



// WEBPACK FOOTER //
// ./src/constants/dashboard.js